export default __webpack_public_path__ + "static/media/banner-170x340-bg-blue-template.5f7aa28f.svg";